import { apiClientWithRefreshToken } from "@/api/apiClient";

export interface NotificationActionType {
    employee_id: string;
    alert_type: "IQAMA_EXPIRY" | "PLANT_ID_EXPIRY";
    alert_notification_status: boolean;
}

export default async function NotificationAction(data: NotificationActionType) {
    const res = await apiClientWithRefreshToken({
        url: "/expiry-alert-logs",
        method: "POST",
        data: data,
    });

    return res.data;
}
